import React from 'react';
import PropTypes from 'prop-types';
import { Image, Grid } from 'semantic-ui-react';
import { isUndefined } from 'lodash';

import ProfileSymbolIndicator from 'PointOfSale/modules/individualServing/component/ProfileSymbolIndicator';
import { ProfileCardDeleteButton } from './ProfileCardDeleteButton';
import { Formatters } from 'Common/Helpers';
import { FALLBACK_IMAGE } from 'Common/Constants';

const ProfileCard = props => {
  const { currentProfile, deleteButtonSettings } = props;
  const { symbolIndicator = [], IdSeed } = currentProfile;

  if (!currentProfile || isUndefined(IdSeed)) {
    return null;
  }
  const hasImage = Boolean(currentProfile.Picture);
  const imageSrc = hasImage
    ? Formatters.prependBase64(currentProfile.Picture)
    : FALLBACK_IMAGE;

  return (
    <React.Fragment>
      <div className={'card-container'}>
        <div className="profile-image-wrapper">
          {deleteButtonSettings && (
            <ProfileCardDeleteButton settings={deleteButtonSettings} />
          )}
          <Image
            fluid
            src={imageSrc}
            alt={`${currentProfile.FullName} Profile Picture`}
          />
        </div>

        <Grid padded className={'header-items'}>
          <Grid.Row className="bg-darken">
            <Grid.Column className="large center" width={16}>
              {currentProfile.FullName}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="bg-darken">
            <Grid.Column className="large center" width={16}>
              {currentProfile.Id}
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>Teacher: {currentProfile.Teacher}</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>Grade: {currentProfile.GradeId}</Grid.Column>
          </Grid.Row>
        </Grid>
        <div className={'indicators'}>
          <ProfileSymbolIndicator symbolIndicator={symbolIndicator} />
        </div>
        <Grid padded className={'balance-items tight tight-y'} columns={2}>
          {props.isTaxRate && (
            <React.Fragment>
              <Grid.Row className="smaller">
                <Grid.Column textAlign={'left'}>Subtotal:</Grid.Column>
                <Grid.Column textAlign={'right'}>
                  {Formatters.balance(props.subtotal)}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="smaller">
                <Grid.Column textAlign={'left'}>Tax:</Grid.Column>
                <Grid.Column textAlign={'right'}>
                  {Formatters.balance(props.tax)}
                </Grid.Column>
              </Grid.Row>
            </React.Fragment>
          )}
          <Grid.Row className="pad-bottom">
            <Grid.Column textAlign={'left'}>Total Due:</Grid.Column>
            <Grid.Column textAlign={'right'} className={'balance-dollars'}>
              {Formatters.balance(props.totalCost)}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign={'left'}>Balance:</Grid.Column>
            <Grid.Column
              textAlign={'right'}
              className={props.pendingBalance < 0 ? 'red-text' : 'green-text'}
            >
              {Formatters.balance(props.pendingBalance)}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign={'left'}>Total Paid:</Grid.Column>
            <Grid.Column textAlign={'right'} className={'total-paid-dollars'}>
              {Formatters.balance(props.amountPaid)}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign={'left'}>Change:</Grid.Column>
            <Grid.Column textAlign={'right'}>
              {Formatters.balance(props.change)}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </React.Fragment>
  );
};

ProfileCard.propTypes = {
  currentProfile: PropTypes.object.isRequired,
  deleteButtonSettings: PropTypes.object,
  pendingBalance: PropTypes.number,
  tax: PropTypes.number,
  isTaxRate: PropTypes.bool,
  subtotal: PropTypes.number,
  totalCost: PropTypes.number,
  change: PropTypes.number,
  amountPaid: PropTypes.string,
};

ProfileCard.defaultProps = {
  currentProfile: {
    name: 'temp',
    balance: 0.0,
    profileURL: '',
  },
  tax: 0,
  isTaxRate: false,
  subtotal: 0,
  totalCost: 0,
  change: 0,
  amountPaid: '',
};

export default ProfileCard;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/component/ProfileCard.js